import React from 'react'
import styles from './cloud.scss'
import product from '../../../common/images/product/product-9.jpg'

const Cloud = (props) => {
  return <section className={styles['advanced']}>
    <div className={styles['advanced-contnet']}>
      <div className={styles['product']}>
        <img src={product} alt='product' />
        <div>
          <h3>概而论云记账</h3>
          <p>您的票财税一体化管理专家</p>
        </div>
      </div>
      <div className={styles['characters']}>
        <h2>云报销</h2>
        {/* <div>
          <p><span>适用群体</span></p>
          <p>对内部管理有一定要求的</p>
          <p>企业单位</p>
        </div> */}
      </div>
      <div className={styles['advanced-table']}>
        <table border='0' cellSpacing='0' cellPadding='0' align='center' width='100%'>
          <tbody>
            <tr className={styles['table-th']}>
              <th>产品版本</th>
              <th colSpan='5'>主要功能</th>
            </tr>
            <tr>
              <td rowSpan='4' className={styles['advanced-gaoji']}><span>云报销</span></td>
              <td colSpan='5' className={styles['advanced-left']}>采购报备、报销申请、备用款申请</td>
            </tr>
            <tr>
              <td colSpan='5' className={styles['advanced-left']}>发票智能采集、验真、去重</td>
            </tr>
            <tr>
              <td colSpan='5' className={styles['advanced-left']}>
                <span>支持小程序端报销发起、</span>
                <span>移动审批、查看报销进度</span>
                <p>支持小程序端报销发起、移动审批、查看报销进度</p>
              </td>
            </tr>
            <tr>
              <td colSpan='5' className={styles['advanced-left']}>费用统计报表</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles['advanced-yd']}>
        <p><span>适用群体</span></p>
        <p>对客户管理、企业内部管理要求较高的中大</p>
        <p>型财税服务机构</p>
      </div>
    </div>
  </section>
}

export default Cloud
